import { useRef } from 'react';
// https://reactjs.org/docs/hooks-faq.html#how-to-create-expensive-objects-lazily
export function useConstant(callback) {
    const ref = useRef();
    if (!ref.current) {
        // Store the result of the callback in an array to allow the callback to
        // return falsy values including null and undefined.
        ref.current = [
            callback()
        ];
    }
    return ref.current[0];
}

//# sourceMappingURL=useConstant.js.map